import welsomeImg from "./../../Assets/Media/Appraisal Benefits latest.png";
import img2 from "./../../Assets/Media/Brokerage Service.png";

export const DataAuctionAppraisalsWelcomeBanner = [
  {
    heading: "It starts at just Rs. 999",
    subheading: "Benefits from Domain Appraisals",
    t1: "Value in dollars",
    t2: "Perfect for price negotiations",
    t3: "Scientifically sound",
    t4: "Unique .Gold domains marketplace",
    button: "Get in touch",
    img: welsomeImg,
  },
];

export const DataBrokerageServiceWelcomeBanner = [
  {
    heading: "Brokerage Service ",
    subheading: "Our professionals buy or sell domains on your behalf.",
    t1: "Most Affordable",
    t2: "Perfect for price negotiations",
    t3: "Scientifically sound",
    t4: "Unique expertise in .Gold Domains ",
    button: "Contact Us",
    img: img2,
  },
];
